import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { useI18n } from "vue-i18n";
import { defineComponent } from "vue";
import { openTopUpForm } from "@/utils/vue-helpers/cash-float";
export default defineComponent({
  name: "SalesClosedBanner",
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var startSales = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return openTopUpForm();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function startSales() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      startSales: startSales,
      t: t
    };
  }
});